<div class="curtain">
    <div class="progress progress-indeterminate">
        <span class="visually-hidden">In elaborazione...</span>
        <div class="progress-bar" role="progressbar"></div>
    </div>
</div>